var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "open-order-ct" },
    [
      _c("Filters", {
        attrs: { isShowStatus: false },
        on: {
          submit: function($event) {
            return _vm.submit($event)
          }
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "tb" },
        [
          _c("open-table", {
            staticClass: "tb_content",
            attrs: { list: _vm.list }
          }),
          _vm._v(" "),
          _c("pagination", {
            staticClass: "__tb_pagination",
            attrs: {
              currentPage: _vm.currentPage,
              toPage: _vm.getOrder,
              totalPage: _vm.totalPage
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }